import { IAction } from "../../../models/Action";
import { immutableSet } from "../../../utils/immutable";
import { actionTypes } from "./actions";
import { STATE_IDENTIFIER } from "./constants";
import emptyState from "./emptyState";

const { NUM_TASK, NUM_APPROVAL, NOTIFY_MSG } = STATE_IDENTIFIER;

const ACTION_HANDLERS = {
  [actionTypes.LOAD_TASK_BADGE_SUCCESS]: (state: any, action: any) =>
    immutableSet([NUM_TASK], action.payload, state),
  [actionTypes.LOAD_TASK_BADGE_FAILURE]: (state: any, action: any) =>
    immutableSet([NUM_TASK], 0, state),

  [actionTypes.LOAD_APPROVAL_BADGE_SUCCESS]: (state: any, action: any) =>
    immutableSet([NUM_APPROVAL], action.payload, state),
  [actionTypes.LOAD_APPROVAL_BADGE_FAILURE]: (state: any, action: any) =>
    immutableSet([NUM_APPROVAL], 0, state),

  [actionTypes.LOAD_NOTIFY_SUCCESS]: (state: any, action: any) => {
    return immutableSet([NOTIFY_MSG], action.payload, state);
  },
  [actionTypes.LOAD_NOTIFY_FAILURE]: (state: any, action: any) =>
    immutableSet([NOTIFY_MSG], [], state),
};

export default function communicationReducer(
  state = emptyState,
  action: IAction
) {
  if (action && action.type === "@@router/LOCATION_CHANGE") {
    return emptyState;
  }
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
